import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { classNames } from '@/util/utils';
import type { ContentForPricingFeatureItem, ContentForPricingPlan } from '@/services/sanity/api/get-pricing-features';
import styles from './feature-cell.module.css';
interface FeatureCellProps {
  feature: ContentForPricingFeatureItem;
  plan: ContentForPricingPlan;
  available: boolean;
}
export default function FeatureCell(t0) {
  const $ = _c(21);
  const {
    feature,
    plan,
    available
  } = t0;
  let t1;
  if ($[0] !== feature.plans || $[1] !== plan) {
    let t2;
    if ($[3] !== plan) {
      t2 = p => p.id === plan.id;
      $[3] = plan;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = feature.plans.find(t2);
    $[0] = feature.plans;
    $[1] = plan;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const item = t1;
  if (!item) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.5em" height="1.5em" fill="var(--color-neutral)"><title>minus</title><path d="M19,13H5V11H19V13Z" /></svg>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  let t3;
  if ($[6] !== available || $[7] !== item.label) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const cls = classNames(styles.featureCell, !available && styles.unavailable);
      if (!item.label) {
        let t4;
        let t5;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <title>check-circle</title>;
          t5 = <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />;
          $[10] = t4;
          $[11] = t5;
        } else {
          t4 = $[10];
          t5 = $[11];
        }
        t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={cls}>{t4}{t5}</svg>;
        break bb0;
      }
      t2 = classNames(cls, styles.tooltip);
    }
    $[6] = available;
    $[7] = item.label;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[12] !== item.label) {
    t4 = <span>{item.label}</span>;
    $[12] = item.label;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== item.tooltip) {
    t5 = item.tooltip && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.5em" height="1.5em" fill="currentColor"><title>information-outline</title><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>;
    $[14] = item.tooltip;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== item.tooltip || $[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <button className={t2} type="button" data-tooltip={item.tooltip}>{t4}{t5}</button>;
    $[16] = item.tooltip;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}